const LinkRoutes = {
  app: "/",
  creditWomen: '/prestamo-solidario',
  resultSearchView: '/resultado-busqueda',
  creditProsperous: '/credito-prospera',
  formDepositFixed: '/canales-abiertos',
  promotionHistory: "/asociados",
  transparency: '/transparencia',
  legal:"/legales",
  complaintsBook: '/reclamos-y-requerimientos',
  flexibleFixedDeposit: '/deposito-a-plazo-fijo-flexible',
  aboutUs: "/quienes-somos",
  ratesAndFees:"/como-funciona",
  payments:"/pagos",               
  creditInsurance: '/seguro-desgravamen',
  creditInsurancePercentage: '/seguro-desgravamen-porcentual',
  safe:"/auto-nuevo",
  contact: "/contactanos",
  digitalChannelSurgir: "/canaldigital",
  digitalChannel: "/canal-digital",
  faqs: "/preguntas-frecuentes",
  dpf:"/deposito-a-plazo-fijo",
  whereWeAre:"/donde-estamos",
 channels: "/canal-abierto",
  listOfNotaries:"/asambleas",
  promociones: "/promociones",
  referidos:"/refiere-y-gana",
  simulator:"/simulador-de-credito",
  depositFixedSantander: '/simulador',
  formdpfLarge: "/formulario-dpf-extendido",
  savingsAccount: 'cuenta-de-ahorros'
};
export default LinkRoutes;
